import moment from 'moment';
import { buildAppointmentServiceFields, normalizeAppointmentAvailabilityDateTime } from '../../pages/calendar/appointmentServiceFields';

export const containedAppointmentChildStart = (values, field, index, fallback) => {
  if (![true, 1, '1'].includes(values?.add_on_within_original_time)) return fallback;
  const primaryStart = normalizeAppointmentAvailabilityDateTime(values.start_datetime)
    || moment(`${values.dateof} ${values.start_time}`, 'dddd, DD MMMM YYYY HH:mm', true).format('YYYY-MM-DD HH:mm:ss');
  const start = moment(primaryStart, 'YYYY-MM-DD HH:mm:ss', true);
  if (!start.isValid()) return fallback;
  const preceding = (values[field] || []).slice(0, Number(index));
  const minutes = preceding.reduce((sum, line) => sum + moment.duration(
    field === 'addonservices' ? buildAppointmentServiceFields(line).duration : buildAppointmentServiceFields(line).durationWithPadding,
  ).asMinutes(), 0) + (field === 'addanotherservices' ? moment.duration(buildAppointmentServiceFields(values).durationWithPadding).asMinutes() : 0);
  return start.add(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');
};
